<template>
  <v-container>
    <v-layout justify-center>
      <v-stepper :value="formStep" style="width: 100%; max-width: 840px;">
          <!---->
        <v-stepper-header style="overflow: auto;">
          <v-stepper-step :complete="currentStep > 1" step="1">{{ $t('registration.steps[0]') }}</v-stepper-step>
          <v-divider/>
          <v-stepper-step :complete="currentStep > 2" step="2">{{ $t('registration.steps[1]') }}</v-stepper-step>
          <v-divider/>
          <v-stepper-step :complete="currentStep > 3" step="3">{{ $t('registration.steps[2]') }}</v-stepper-step>
          <v-divider/>
          <v-stepper-step :complete="currentStep > 4" step="4">{{ $t('registration.steps[3]') }}</v-stepper-step>
          <v-divider/>
          <v-stepper-step step="5">{{ $t('registration.steps[4]') }}</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="0">
            <registration-intro ref="registrationIntro"></registration-intro>
            <div class="text-xs-right">
              <v-btn
                flat
                @click="$router.push({name: 'eventList'})"
              >
                {{ $t('registration.cancel') }}
              </v-btn>
              <v-btn
                color="primary"
                @click="nextStep"
              >
                {{ $t('registration.continue') }}
              </v-btn>
            </div>
          </v-stepper-content>
          <v-stepper-content step="1">
            <player-info ref="playerInfo"></player-info>
            <div class="text-xs-right">
              <v-btn
                flat
                @click="$router.push({name: 'eventList'})"
              >
                {{ $t('registration.cancel') }}
              </v-btn>
              <v-btn
                color="primary"
                @click="nextStep"
              >
                {{ $t('registration.continue') }}
              </v-btn>
            </div>
          </v-stepper-content>
          <!---->
          <v-stepper-content step="2">
            <waivers-review ref="waiversReview"></waivers-review>
            <div class="text-xs-right">
              <v-btn
                flat
                @click="$router.push({name: 'eventList'})"
              >
                {{ $t('registration.cancel') }}
              </v-btn>
              <v-btn
                color="primary"
                @click="nextStep"
              >
                {{ $t('registration.continue') }}
              </v-btn>
            </div>
          </v-stepper-content>
          <!---->
          <v-stepper-content step="3">
            <event-confirmation ref="eventConfirmation"></event-confirmation>
            <div class="text-xs-right">
              <v-btn
                flat
                @click="$router.push({name: 'eventList'})"
              >
                {{ $t('registration.cancel') }}
              </v-btn>
              <v-btn
                color="primary"
                @click="nextStep"
              >
                {{ $t('registration.continue') }}
              </v-btn>
            </div>
          </v-stepper-content>
          <!---->
          <v-stepper-content step="4">
            <reg-payment ref="regPayment"></reg-payment>
            <div class="text-xs-right">
              <v-btn
                flat
                @click="$router.push({name: 'eventList'})"
              >
                {{ $t('registration.cancel') }}
              </v-btn>
              <v-btn
                color="primary"
                @click="nextStep"
              >
                {{ $t('registration.continue') }}
              </v-btn>
            </div>
          </v-stepper-content>
          <!---->
          <v-stepper-content step="5">
            <reg-complete></reg-complete>
            <div class="text-xs-right">
              <v-btn
                color="primary"
                @click="lastStep"
              >
                Complete
              </v-btn>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-layout>
    <v-dialog
      v-model="loading"
      persistent
      width="200"
    >
    <v-card class="loader">
      <v-card-text>
        <p class="body-1">{{ loadingMessage }}</p>
        <v-progress-circular
          indeterminate
          size="70"
          color="primary">
        </v-progress-circular>
      </v-card-text>
    </v-card>
    </v-dialog>
    <v-dialog
      v-model="errorDialog"
      persistent
      max-width="300"
    >
      <v-card>
        <v-card-title class="headline">
          <v-icon color="red darken-1" >error</v-icon>
          Error
        </v-card-title>
        <v-divider />
        <v-card-text>{{ errorMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click="errorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import registrationIntro from '../components/forms/RegistrationIntro'
import playerInfo from '../components/forms/PlayerInfo'
import waiversReview from '../components/forms/WaiversReview'
import eventConfirmation from '../components/forms/EventConfirmation'
import regPayment from '../components/forms/RegPayment'
import regComplete from '../components/forms/RegComplete'

export default {
  name: 'RegistrationForm',
  components: {
    registrationIntro,
    playerInfo,
    waiversReview,
    eventConfirmation,
    regPayment,
    regComplete
  },
  data(){
    return{
      currentStep: 0,
      loading: false,
      loadingMessage: 'Loading...',
      errorDialog: false,
      errorMessage: ''
    }
  },
  computed: {
    formStep () {
      return this.$route.params.step
    }
  },
  methods: {
    nextStep () {
      let result = null
      switch (this.currentStep) {
        case 0:
          this.$store.commit('clearRegistrations')
          this.$store.commit('clearCurrentRegistration')
          this.$store.commit('clearTransaction')
          this.currentStep++
          this.$router.push({name: 'registrationForm', params:{step : this.currentStep}})
        break
        case 1:
          if  (!this.$refs.playerInfo.isValid()) return
          this.currentStep++
          this.$router.push({name: 'registrationForm', params:{step : this.currentStep}})
        break
        case 2:
          if (!this.$refs.waiversReview.isValid()) return
          this.currentStep++
          this.$router.push({name: 'registrationForm', params:{step : this.currentStep}})
        break
        case 3:
          this.processEvents()
        break
        case 4:
          result = this.$refs.regPayment.validate()
          if (result) {
            this.makePayment(result)
          } else {
            return
          }
        break
        default:
          this.currentStep++
          this.$router.push({name: 'registrationForm', params:{step : this.currentStep}})
      }
    },
    lastStep () {
      this.$store.commit('clearRegistrations')
      this.$store.commit('clearCurrentRegistration')
      this.$store.commit('clearTransaction')
      this.currentStep = 0
      this.$router.push('/')
    },
    registerForEvent: async function(id){
      return await this.$store.dispatch('registerForEvent', id)
    },
    makePayment: async function(info) {
      this.loadingMessage = 'Processing payment...'
      this.loading = true
      let regGroupId = this.$store.state.registrations[0].registration_group_id
      let paymentResults = await this.$store.dispatch('payRegistration', {...info, regId: regGroupId})
      let transaction = paymentResults.transaction
      let regStatus = Array.isArray(paymentResults.registration_status) ? paymentResults.registration_status : null
      let hasEmailError = false
      let hasPaymentError = false
      let chargeSuccess = true
      if (paymentResults.error) {
        this.loading = false
        this.errorMessage = paymentResults.error_detail
        this.errorDialog = true
        return
      }
      if(Array.isArray(regStatus)){
        for(let i = 0; i < regStatus.length; i++) {
          try {
            this.$store.state.registrations.find( r=> r.id === regStatus[i].registration_id).status = regStatus[i].registration_status
          } catch(e) {
            this.errorMessage = e.message
            this.errorDialog = true
          }
          if(regStatus[i].email_error) hasEmailError = true
          if(regStatus[i].charge_success === 0 && regStatus[i].registration_status === 'pending') {
            chargeSuccess = false
            hasPaymentError = true
          }
        }
        if (hasEmailError) {
          this.loading = false
          this.errorMessage = 'There was an error sending your confirmation email.'
          this.errorDialog = true
        }
        if (hasPaymentError) {
          this.loading = false
          this.errorMessage = 'There was an unknown error processing your payment.'
          this.errorDialog = true
        }
        if (chargeSuccess) {
          this.loading = false
          this.$store.commit('setTransaction', transaction)
          this.currentStep++
          this.$router.push({name: 'registrationForm', params:{step : this.currentStep}})
        }
      }
    },
    processEvents() {
      let p = []
      this.loadingMessage = 'Registering player..'
      this.loading = true
      const events = this.$refs.eventConfirmation.addEvents()
      this.registerForEvent(events[0])
        .then(() => {
          if (events.length > 1) {
            for (let i = 1; i < events.length; i++) {
              p.push( this.registerForEvent(events[i]) )
            }
            let requiresPayment = false
              Promise.all(p).then(regs => {
                this.loadingMessage = ''
                this.loading = false
                this.$store.state.registrations.forEach(r => {
                  if(r.status === 'pending'){
                    requiresPayment = true
                  }
                })
              if(requiresPayment) {
                // Go to payment form screen -- pending
                this.currentStep++
                this.$router.push({name: 'registrationForm', params:{step : this.currentStep}})
              } else {
                // Go to complete screen -- waitlist/completed
                this.currentStep += 2
                this.$router.push({name: 'registrationForm', params:{step: this.currentStep}})
              }
            }).catch(err => {
              this.errorMessage ='We\'ve run into an issue registering you for our event. Please try again. If problem persists, please contact us at: januszm@floridapanthers.com.'
              this.errorDialog = true
              // eslint-disable-next-line
              console.error(err)
            })
          } else {
            let requiresPayment = false
            requiresPayment = this.$store.state.registrations[0].status == 'pending' ? true : false
            this.loadingMessage = ''
            this.loading = false
            if(requiresPayment) {
              // Go to payment form screen -- pending
              this.currentStep++
              this.$router.push({name: 'registrationForm', params:{step : this.currentStep}})
            } else {
              // Go to complete screen -- waitlist/completed
              this.currentStep += 2
              this.$router.push({name: 'registrationForm', params:{step: this.currentStep}})
            }
          }
      }).catch(err => {
        this.errorMessage = 'We\'ve run into an issue registering you for our event. Please try again. If problem persists, please contact us at: januszm@floridapanthers.com.'
        this.errorDialog = true
        // eslint-disable-next-line
        console.error(err)
      })
    }
  },
  // eslint-disable-next-line
  beforeRouteUpdate (to, from, next) {
    if (to.params.step === this.currentStep) next()
    else {
      if (this.currentStep > 3) next(false)
      else {
        if(parseInt(to.params.step) < 4) {
          this.currentStep = parseInt(to.params.step)
          next()
        }
        else next(false)
      }
    }
  }
}
</script>

<style scoped>
.loader {
  width: 200px;
  height: 200px;
  box-shadow: none;
  text-align: center;
  padding-top: 30px;
}

</style>